import { render } from "./createClient.html?vue&type=template&id=7955ec4d&scoped=true&ts=true&external"
import script from "./CreateClient.vue?vue&type=script&lang=ts"
export * from "./CreateClient.vue?vue&type=script&lang=ts"

import "./CreateClient.vue?vue&type=style&index=0&id=7955ec4d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7955ec4d"]])

export default __exports__